











import { defineComponent, ref, toRefs, PropType, computed } from '@vue/composition-api';
import {
  CampaignFormData,
  AdgroupFormData,
  CreateMode,
  PromotionFlowType as PromotionFlowTypeEnum,
} from '@tt4b/ttam-enums';
import PromotionFlowType from './index';
import { useAdgroupMode } from '@tt4b/ttam-hooks';

const name = 'ttam-promotion-flow-type-compose';
export default defineComponent({
  name,
  components: {
    TtamPromotionFlowType: PromotionFlowType.TtamPromotionFlowType,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    hasShop: {
      type: Boolean,
      default: false,
    },
    hasShowcase: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, hasShop, hasShowcase, createMode } = toRefs(props);
    const formItem = ref(null);
    const { isEdit, isCopy } = useAdgroupMode({ createMode });
    const type = computed({
      get: () => adgroupData.value.promotionFlowType,
      set: (val: PromotionFlowTypeEnum) => {
        emit('input', val);
        // 手动触发校验更新状态
        setTimeout(() => formItem.value?.validate('change'), 0);
      },
    });
    const { data } = PromotionFlowType.usePropsData({
      campaignData,
      adgroupData,
      hasShop,
      hasShowcase,
      isCopy,
      isEdit,
    });
    const { adTypeValidator } = PromotionFlowType.useRules(campaignData);
    return {
      name,
      isEdit,
      type,
      data,
      formItem,
      adTypeValidator,
    };
  },
});
